<template>
  <div class="icon-language">
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="language">
        <mask
          id="mask0_92_282"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <rect id="Bounding box" y="0.217041" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_92_282)">
          <path
            id="language_2"
            d="M12 21.717C10.6975 21.717 9.46833 21.4674 8.3125 20.968C7.15667 20.4687 6.14867 19.7889 5.2885 18.9285C4.42817 18.0684 3.74833 17.0604 3.249 15.9045C2.74967 14.7487 2.5 13.5195 2.5 12.217C2.5 10.9042 2.74967 9.67246 3.249 8.52179C3.74833 7.37112 4.42817 6.36571 5.2885 5.50554C6.14867 4.64521 7.15667 3.96537 8.3125 3.46604C9.46833 2.96671 10.6975 2.71704 12 2.71704C13.3128 2.71704 14.5446 2.96671 15.6953 3.46604C16.8459 3.96537 17.8513 4.64521 18.7115 5.50554C19.5718 6.36571 20.2517 7.37112 20.751 8.52179C21.2503 9.67246 21.5 10.9042 21.5 12.217C21.5 13.5195 21.2503 14.7487 20.751 15.9045C20.2517 17.0604 19.5718 18.0684 18.7115 18.9285C17.8513 19.7889 16.8459 20.4687 15.6953 20.968C14.5446 21.4674 13.3128 21.717 12 21.717ZM12 20.1958C12.5103 19.519 12.9398 18.8363 13.2885 18.1478C13.6372 17.4593 13.9212 16.7067 14.1405 15.89H9.8595C10.0917 16.7324 10.3789 17.4978 10.7213 18.1863C11.0634 18.8748 11.4897 19.5446 12 20.1958ZM10.0635 19.9208C9.68017 19.3708 9.33592 18.7455 9.03075 18.045C8.72558 17.3444 8.48842 16.626 8.31925 15.89H4.927C5.45517 16.9285 6.1635 17.801 7.052 18.5075C7.9405 19.2139 8.94433 19.685 10.0635 19.9208ZM13.9365 19.9208C15.0557 19.685 16.0595 19.2139 16.948 18.5075C17.8365 17.801 18.5448 16.9285 19.073 15.89H15.6807C15.4794 16.6324 15.2262 17.3539 14.921 18.0545C14.616 18.7552 14.2878 19.3773 13.9365 19.9208ZM4.298 14.39H8.0155C7.95267 14.0184 7.90708 13.654 7.87875 13.2968C7.85058 12.9398 7.8365 12.5799 7.8365 12.217C7.8365 11.8542 7.85058 11.4943 7.87875 11.1373C7.90708 10.7801 7.95267 10.4157 8.0155 10.044H4.298C4.20183 10.3837 4.12817 10.7369 4.077 11.1035C4.02567 11.4702 4 11.8414 4 12.217C4 12.5927 4.02567 12.9639 4.077 13.3305C4.12817 13.6972 4.20183 14.0504 4.298 14.39ZM9.51525 14.39H14.4848C14.5474 14.0184 14.5929 13.6572 14.6212 13.3065C14.6494 12.9559 14.6635 12.5927 14.6635 12.217C14.6635 11.8414 14.6494 11.4782 14.6212 11.1275C14.5929 10.7769 14.5474 10.4157 14.4848 10.044H9.51525C9.45258 10.4157 9.40708 10.7769 9.37875 11.1275C9.35058 11.4782 9.3365 11.8414 9.3365 12.217C9.3365 12.5927 9.35058 12.9559 9.37875 13.3065C9.40708 13.6572 9.45258 14.0184 9.51525 14.39ZM15.9845 14.39H19.702C19.7982 14.0504 19.8718 13.6972 19.923 13.3305C19.9743 12.9639 20 12.5927 20 12.217C20 11.8414 19.9743 11.4702 19.923 11.1035C19.8718 10.7369 19.7982 10.3837 19.702 10.044H15.9845C16.0473 10.4157 16.0929 10.7801 16.1212 11.1373C16.1494 11.4943 16.1635 11.8542 16.1635 12.217C16.1635 12.5799 16.1494 12.9398 16.1212 13.2968C16.0929 13.654 16.0473 14.0184 15.9845 14.39ZM15.6807 8.54404H19.073C18.5385 7.49271 17.835 6.62021 16.9625 5.92654C16.09 5.23304 15.0813 4.75871 13.9365 4.50354C14.3198 5.08554 14.6608 5.72212 14.9595 6.41329C15.2583 7.10429 15.4987 7.81454 15.6807 8.54404ZM9.8595 8.54404H14.1405C13.9083 7.70804 13.6163 6.93779 13.2645 6.23329C12.9125 5.52879 12.491 4.86379 12 4.23829C11.509 4.86379 11.0875 5.52879 10.7355 6.23329C10.3837 6.93779 10.0917 7.70804 9.8595 8.54404ZM4.927 8.54404H8.31925C8.50125 7.81454 8.74167 7.10429 9.0405 6.41329C9.33917 5.72212 9.68017 5.08554 10.0635 4.50354C8.91217 4.75871 7.90192 5.23471 7.03275 5.93154C6.16342 6.62821 5.4615 7.49904 4.927 8.54404Z"
            fill="#1C1B1F"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'IconLanguage'
})
</script>

<style>
.icon-language {
  height: 24px;
  position: relative;
  width: 24px;
}
.icon-language .img {
  height: 20px;
  left: 3px;
  position: relative;
  top: 2px;
  width: 20px;
}
.icon-language path {
  fill: white;
}
</style>
